import React from 'react';
import './../index.css';

export class LevelLinks extends React.Component {

  onClick(url) {
    window.open(url.trim(), "_blank");
  }

  renderButton(index) {
    let button;

    if (this.props.links[index].url.indexOf("drive.google.com") > 0) {
      button = <a href={this.props.links[index].url} download={this.props.links[index].url.substring(this.props.links[index].url.lastIndexOf("/"))}>
        <button className='openButton' type="button">Download</button>
      </a>;
    } else {
      button = <a href={this.props.links[index].url} target="_blank">
        <button className='openButton' type="button">Open</button>
      </a>;
      /* 
            button = <input className='openButton' type='button' onClick={() => this.onClick(this.props.links[index].url)}
              value='OPEN' />; */
    }

    return button;
  }

  render() {
    const links = this.props.links;
    return (
      <>
        {
          /*
          * Level link section
          */
        }

        {links && links.length > 0 &&
          <div >
            <table className='linkTable'>
              <tbody className='linkTableBody'>
                {
                  links.map(
                    (currentLink, index) =>
                      <tr key={currentLink.text} className='linkTableRow'>
                        <td className='linkTableCellText'>
                          <span dangerouslySetInnerHTML={{ __html: currentLink.text }}></span>
                        </td>
                        <td className='linkTableCellLink'>
                          <a href={this.props.links[index].url} target="_blank">
                            <button className='openButton' type="button">Open</button>
                          </a>
                        </td>
                      </tr>
                  )
                }
              </tbody>
            </table>
          </div>

        }

      </>
    );
  }


}
